module.exports = __webpack_public_path__ + "static/media/orange04.74182498.svg";